export const STATUS_META = {
  draft: { label: "Draft (hidden)", cls: "bg-[#EDE7DF] text-[#6D5A50]" },
  coming_soon: { label: "Coming Soon", cls: "bg-[#FFF4D6] text-[#6D4C1F]" },
  live: { label: "Live — for sale", cls: "bg-[#E6EFD9] text-[#4E6B2F]" },
};

export const SUPPLIER_LABEL = { printful: "Printful", printed_mint: "Printed Mint" };

export const inputCls =
  "w-full rounded border border-[#D9CBB8] bg-white px-3 py-2 text-sm text-[#2C2724] focus:outline-none focus:border-[#4B3A2F]";

export const btn = {
  primary: "rounded-full bg-[#4B3A2F] text-[#F9F6F0] px-5 py-2 text-xs uppercase tracking-[0.15em] hover:bg-[#3a2c23] disabled:opacity-50 transition-colors duration-300",
  ghost: "rounded-full border border-[#D9CBB8] bg-white text-[#4B3A2F] px-4 py-2 text-xs uppercase tracking-[0.15em] hover:border-[#4B3A2F] disabled:opacity-50 transition-colors duration-300",
  danger: "rounded-full border border-[#E5B4AE] bg-white text-[#A3302A] px-4 py-2 text-xs uppercase tracking-[0.15em] hover:bg-[#FBE9E7] transition-colors duration-300",
};

export const StatusBadge = ({ status, testid }) => {
  const m = STATUS_META[status] || STATUS_META.draft;
  return <span data-testid={testid} className={`px-3 py-1 rounded-full text-[11px] uppercase tracking-[0.15em] ${m.cls}`}>{m.label}</span>;
};

export const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="text-[10px] uppercase tracking-[0.25em] text-[#6D5A50]">{label}</span>
    <div className="mt-1">{children}</div>
    {hint && <span className="block text-xs text-[#8D7B6E] mt-1 italic">{hint}</span>}
  </label>
);
